<template>
    <div class="main_container">
        <el-tabs type="border-card">
            <el-tab-pane label="申请预览">
                <div class="view_mian">
                    <div class="title_sty">申请人基本信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">申请人姓名：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{formData.RequesterName}}</div></el-col>
                    </el-row>
                     <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">申请人电话：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{formData.RequesterPhoneNum}}</div></el-col>
                    </el-row>
                    <!-- <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">所在单位：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{formData.RequesterOrganisation}}</div></el-col>
                    </el-row> -->
                    <!-- <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">个人身份证明：</div></el-col>
                        <el-col :span="20">
                            <div class="grid-content bg-purple-light info_con" v-for="item in formData.PersonIdentification" :key="item.FileGuid">
                               
                                    <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid" >
                                        <ul style="display:inline-block;">
                                            <li style="display:inline-block;" ><span  class="input_fileName" style="display:inline-block;color:#606266;">{{item.FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid"></a></li>
                                        </ul>
                                        <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                            下载
                                        </a>
                                    </div>
                            </div>
                        </el-col>
                    </el-row> -->
                    <div class="title_sty">待撤文章信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">题目名称：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{formData.ArticleName }}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">作者：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{formData.Author }}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">检测报告单：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">
                            <!-- {{formData.CheckReport[0].FileName}} -->
                            <div :id="'indexImg_'+formData.CheckReport[0].FileGuid" :ref="'indexImg_'+formData.CheckReport[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{formData.CheckReport[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(formData.CheckReport[0].FileGuid,'pdf')">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+formData.CheckReport[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+formData.CheckReport[0].FileGuid" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">待撤文章位置：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">
                            <!-- {{formData.ArticleLocation[0].FileName }} -->
                            <div :id="'indexImg_'+formData.ArticleLocation[0].FileGuid" :ref="'indexImg_'+formData.ArticleLocation[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{formData.ArticleLocation[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(formData.ArticleLocation[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+formData.ArticleLocation[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+formData.ArticleLocation[0].FileGuid" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <div class="btn_box">
                        <el-button type="primary" @click="updataApply" class="updata_btn" >修改</el-button>
                        <el-button type="primary" @click="submitInfo" class="submit_btn">提交</el-button>
                    </div>

                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    data(){
        return{
            authImgUrl:BASE_URL
        }
    },
    methods:{
        showImgFn(FileGuid,Clicktype){
            if(Clicktype){
                var url = this.authImgUrl+'/api/Common/GetOriginalFile?BatchID='+FileGuid;
                window.open(location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                return false;
            }
            var _this = this;
            console.log("_this[FileGuid]=====",_this[FileGuid]);
            var ViewerDom = document.getElementById('indexImg_'+FileGuid);
            console.log("ViewerDom===",ViewerDom)
            // debugger
            if(!_this[FileGuid]){
                _this[FileGuid] = new Viewer(document.getElementById('indexImg_'+FileGuid), {
                // 相关配置项,详情见下面
                inline: false,  //是否启用 inline 模式
                url: 'data-original',  //设置大图片的 url
                navbar: false,  //显示缩略图导航
                zoomRatio: 0.4,  //鼠标滚动时的缩放比例
                // minZoomRatio:0.01, //最小缩放比例
                // maxZoomRatio:100, //最大缩放比例
                // zIndex:2015, //设置图片查看器 modal 模式时的 z-index
                button: true,  //显示右上角关闭按钮（jQuery 版本无效）
                title: true,  //显示当前图片的标题（现实 alt 属性及图片尺寸）
                keyboard: true,  //是否支持键盘
                movable: true,  //图片是否可移动
                tooltip: true,  //显示缩放百分比
                // rotatable: true,  //图片是否可旋转
                // scalable: true,  //图片是否可翻转
                toolbar: {   //显示工具栏
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 0,
                    play: 0,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                viewed: function () {
                    _this[FileGuid].view(0);
                }
            });
            }

            _this[FileGuid].show();

        },
        updataApply(){
            console.log('viewCancel111111111', this.$route.params.type);
            this.$router.push({
                name: '提交撤除申请',
                params: {
                    formData1: this.formData
                },
                query: {
                    type: this.$route.params.type
                }
            });
            sessionStorage.setItem("formData1",JSON.stringify(this.formData));
            sessionStorage.setItem("btnType","2");
        },
        submitInfo(){
            // this.$router.push("/applyRecord");
           this.CommitRequest(this.formData);
        },
        CommitRequest(formData){
            var _this = this;
            _this.$api.CommitRequest(formData).then(res=>{
                if(res.data.result){
                    this.$message({
                        message: "提交成功",
                        type: 'success',
                        duration: 5 * 1000
                    })
                    sessionStorage.setItem("formData1", "");
                    this.$router.push("/applyRecord");
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                // console.log(res)
            })
        },

    },
    created(){
        if(this.$route.params&&this.$route.params.formData){
            this.formData = this.$route.params.formData;
        }else if(sessionStorage.getItem("formData1")){
            this.formData = JSON.parse(sessionStorage.getItem("formData1"));
        }else{
            this.$message({
                message: "请从新提交撤除申请",
                type: 'error',
                duration: 5 * 1000
            })
        }

        //console.log("formData",this.formData);
    }

}
</script>

<style  scoped>
.view_mian{
    padding:30px 50px
}
.info_item{
    line-height: 40px;
    font-size: 14px;
    color:#606266;
}
.info_title{
    text-align: right;
}
.btn_box{
    margin-left:42%;
}

</style>



// WEBPACK FOOTER //
// viewCancel.vue?3edc7c84